import { useBuilderManager } from 'pages/Cash/pages/BuilderHome/BuilderManager.hook';
import React from 'react';
import { useSelector } from 'react-redux';
import { getSessionRole, USER_ROLE } from 'helpers/session';
import { useSesameCash } from 'pages/SesameCashEnrollment/hooks/sesameCashHelper.hook';

export const withSesameCash = Cmp => {
  const WithSesameCashHoC = props => {
    const { ocfLoggedIn } = useSelector(state => ({
      ocfLoggedIn: state.app.ocfLoggedIn,
    }));
    const isUserSessionActive = getSessionRole() === USER_ROLE;
    const isOcfRole = ocfLoggedIn === true;
    const isCashEnrolled =
      props.userInfo && props.userInfo.banking
        ? props.userInfo.banking.enrollStatus === 'REGISTERED'
        : false;
    const cashState = useSesameCash(
      props.userInfo,
      props.config,
      isUserSessionActive && isOcfRole && isCashEnrolled,
    );
    const {
      sesameCashAccount,
      cashAccountError,
      cashAccountLoading,
      cashPinToken,
      cashPinTokenLoading,
      cashPinTokenError,
      loading,
    } = cashState;
    const builderManager = useBuilderManager({
      userInfo: props.userInfo,
      sesameCashAccount: sesameCashAccount,
      sesameCashState: cashState,
    });

    const requestWillStart =
      isCashEnrolled &&
      ((!cashPinToken && !cashPinTokenError) ||
        (cashPinToken && !sesameCashAccount && !cashAccountError));

    let cashLoading =
      cashPinTokenLoading || cashAccountLoading || requestWillStart || loading;
    return (
      <Cmp
        {...props}
        cashPinToken={cashPinToken}
        cashAccount={sesameCashAccount}
        builderManager={builderManager}
        cashLoading={cashLoading}
        cashAccountError={cashAccountError}
        cashPinTokenError={cashPinTokenError}
      />
    );
  };
  return WithSesameCashHoC;
};
